import React, { FC } from 'react';
import { useTranslation } from '../../../tools/i18n';
import StaticCarousel from '../../Carousel/StaticCarousel';
import { Picto } from '../../Picto';

interface ResultArticlesProps {
  activities: any[];
  requirements: any;
}

const ResultArticles: FC<ResultArticlesProps> = ({ activities, requirements }) => {
  const { t } = useTranslation();
  if (!activities?.length) return null;
  return (
    <div className="Articles">
      <div className="articles-header">
        <Picto iconKey="voyages" width="28" height="28" />
        <span>{t('travelPlaner.Travel.articles.title')}</span>
      </div>
      <StaticCarousel
        label=""
        subLabel=""
        slides={activities}
        requirements={requirements}
        className="travel-carousel"
      />
    </div>
  );
};

export default ResultArticles;
